import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { lumConfig } from '@app/core/_config/lum.config';
import { RfqService } from '@app/core/quotes';
import { imageUtility } from '@app/shared/utils/image-utility';

@Component({
  selector: 'rfq-image-form-popup',
  templateUrl: './rfq-image-form-popup.component.html',
  styleUrls: ['./rfq-image-form-popup.component.scss'],
})
export class RfqImageFormPopupComponent implements OnInit {
  @Input() skuId :any;

  loading :boolean;
  formData :UntypedFormGroup;
  images :File[] = [];
  submitted :any;

  constructor(
    public rfqService :RfqService,
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    private toastr :ToastrService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      sku_id: this.skuId,
      images: [''],
      file: null,
    });
    this.loading = false;
  }

  onFileChange(event :any) {
    this.images = [];
    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.images.push(event.target.files[i]);
      }
    }
  }

  save() {
    const payloadFormData = new FormData();
    payloadFormData.append('sku_id', this.formData.controls['sku_id'].value);
    const imagesLength = this.images.length;
    let errorMessage = null;

    for (let i = 0; i < imagesLength; i++) {
      if (this.images[i]?.size <= lumConfig.imageFileSizeLimit) {
        payloadFormData.append('images[]', this.images[i]);
      } else {
        errorMessage =
          'The image size of ' +
          this.images[i]?.name +
          ' is above the file size limit of ' +
          imageUtility.convertFromBytes(lumConfig.imageFileSizeLimit) +
          '.';
        this.toastr.error(errorMessage);
      }
    }

    if (errorMessage) {
      return;
    }

    this.loading = true;
    this.rfqService.uploadImages(payloadFormData).subscribe(
      (resp) => {
        if (resp) {
          this.toastr.success('Image(s) uploaded.');
          this.loading = false;
          this.activeModal.dismiss();
        } else {
          errorMessage =
            'One or more images uploaded is above the file size limit of ' +
            imageUtility.convertFromBytes(lumConfig.imageFileSizeLimit) +
            '.';

          this.loading = false;
          this.toastr.error(errorMessage);
          this.cd.detectChanges();
        }
      },
      (error) => {
        errorMessage =
          'Error when uploading images. Please try again later or contact support.';
        if (this.images.length === 0) {
          errorMessage = 'No image has been selected.';
        }

        this.loading = false;
        this.toastr.error(errorMessage);
        this.cd.detectChanges();
      },
    );
  }

  get noFileSelectedOrIsLoading() :boolean {
    return this.loading || this.images.length === 0;
  }
}
